// В.2.g / В.2.h-rebalance: Главврач Ариана (liv_glavvrach_arena, Герой Лив Лайф, 1/0/15).
// Пассивка: «[Аура]: восстанавливает 1 ХП самому раненому союзнику
// (включая себя)». В rebalance-балансе хил снижен с 2 до 1.
//
// Срабатывает в Ф3 на ОБОИХ раундах хил-прохода (раунд 1 ДО авто-атак,
// раунд 2 ПОСЛЕ).
//
// Кандидаты — союзный Герой (сама Ариана) + все живые союзные юниты.
//   - Цели на ПОЛНОМ ХП исключаются.
//   - Сравниваем по абсолютному недобору (max_hp - current_hp): чем больше
//     недобор, тем «более раненый». Тай-брейк случайный через rng.
//   - На цель — healUnit(target, 2, source=arena). Триггерит событие healed
//     (важно для Бьорка).
//
// Молчание Арианы блокирует Ауру (это уже в каркасе runLivLifeHealAuras —
// он проверяет silenced на самой Ариане).

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const HERO_ID = 'liv_glavvrach_arena';
const HEAL_AMOUNT = 1;

registerImplementedAbility(HERO_ID, 'passive');

registerLivLifeHealAura(HERO_ID, (state, arena, _round) => {
  const ownerIdx = arena.ownerId;
  if (ownerIdx == null) return;
  const owner = state.players[ownerIdx];
  if (!owner) return;
  // Кандидаты: Ариана + все живые союзные юниты с current_hp < max_hp.
  const candidates = [];
  if (owner.hero && owner.hero.hp > 0) {
    const cur = owner.hero.current?.hp ?? owner.hero.hp;
    const max = owner.hero.base?.hp ?? cur;
    if (cur < max) candidates.push(owner.hero);
  }
  for (const u of owner.unitsOnField()) {
    if (!u.isAlive()) continue;
    const cur = u.current?.hp ?? 0;
    const max = u.base?.hp ?? 0;
    if (cur < max) candidates.push(u);
  }
  if (candidates.length === 0) return;
  // Самый раненый = максимальный недобор (max_hp - current_hp).
  let maxDeficit = -Infinity;
  for (const c of candidates) {
    const cur = c.current?.hp ?? c.hp ?? 0;
    const max = c.base?.hp ?? 0;
    const deficit = max - cur;
    if (deficit > maxDeficit) maxDeficit = deficit;
  }
  const tied = candidates.filter(c => {
    const cur = c.current?.hp ?? c.hp ?? 0;
    const max = c.base?.hp ?? 0;
    return (max - cur) === maxDeficit;
  });
  const target = tied.length === 1 ? tied[0] : tied[state.rng.int(tied.length)];
  healUnit(state, target, HEAL_AMOUNT, arena);
});
